
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/odyssey/[chapterId]/key",
      function () {
        return require("private-next-pages/odyssey/[chapterId]/key.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/odyssey/[chapterId]/key"])
      });
    }
  